import samplePdf from "assets/sample.pdf";
import { ReadingMaterialProps } from "../../store/actionType";
import { DownloadIcon } from "assets";
import { useMemo } from "react";

interface Props {
  rMData: ReadingMaterialProps | null | undefined;
  previewUrl?: string | null;
  onClose?: () => void;
}

const PreviewReadingMaterial: React.FC<Props> = ({
  rMData,
  onClose,
  previewUrl,
}) => {
  const urlToPreview = useMemo(() => {
    return previewUrl ?? rMData?.pdf ?? null;
  }, [previewUrl, rMData?.pdf]);
  return (
    <div className="p-4 flex-1 flex flex-col">
      {urlToPreview ? (
        <div className="text-gray-700 border bg-primary-500 shadow-sm rounded-md overflow-hidden">
          {/* Header with title + download button */}
          <div className="flex items-center justify-between p-2">
            <h2 className="text-center text-white font-semibold px-4">
              {rMData?.name}
            </h2>
            <a
              href={urlToPreview}
              download={`${rMData?.name || "reading-material"}.pdf`}
              className="px-3 py-1 bg-white text-primary-600 text-xs font-medium rounded-md hover:bg-primary-100 transition flex items-center"
            >
              Download <DownloadIcon className="size-3 ml-1" />
            </a>
          </div>

          <iframe
            key={urlToPreview} // helps React know when to fully remount
            src={`${urlToPreview}#toolbar=0&navpanes=0&scrollbar=0`}
            className="w-full h-[50vh] border-t"
            style={{ border: "none" }}
          />
        </div>
      ) : (
        <p className="italic text-gray-400 flex justify-center items-center h-full">
          No reading material available...
        </p>
      )}
    </div>
  );
};

export default PreviewReadingMaterial;
